import React, { useContext, useMemo } from 'react'
import totalConsumption, { CountryData } from 'data/total-consumption.csv'
import { getClosestCountryConsumptionWise } from 'lib/getClosestCountry'
import { Consumption } from 'contexts/consumption'
import { getMemoisedYearlyConsumption } from 'lib/calculations'
import { Locale } from 'contexts/locale'
import IntlMessageFormat from 'intl-messageformat'
import { extractValue } from 'lib/extractValue'
import { getFormatVolume } from 'lib/formatters'
import { mean } from 'd3-array'
import { comparisonScale } from 'lib/comparisonScale'

export function CountryComparison() {
  const consumption = useContext(Consumption)
  const yearlyConsumption = getMemoisedYearlyConsumption(consumption)
  const country = useMemo(
    () =>
      getClosestCountryConsumptionWise(
        yearlyConsumption,
        totalConsumption,
        consumption.isFemale
      ),
    [yearlyConsumption, consumption.isFemale]
  )
  const rating = useMemo(() => {
    const indexer = consumption.isFemale ? 'Female' : 'Male'
    const average = mean(totalConsumption, d => extractValue(d[indexer]))
    const difference = extractValue(country[indexer]) - average
    return comparisonScale(difference / average)
  }, [consumption.isFemale, country])

  const locale = useContext(Locale)
  const messages = require('./locales/' + locale + '.yml')
  const countryTranslations = require('locales/countries.' + locale + '.yml')
  const message = new IntlMessageFormat(messages['message'], locale + '-CH')
  const formatVolume = getFormatVolume(locale)

  return (
    <p
      dangerouslySetInnerHTML={{
        __html: message.format({
          gender: consumption.isFemale ? 'female' : 'male',
          country: countryTranslations[country.Country],
          amount: formatVolume.format(
            extractValue(country[consumption.isFemale ? 'Female' : 'Male'])
          ),
          rating: rating || 'same'
        })
      }}
    />
  )
}
